import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { SeFeCardModule } from 'se-fe-card'
import { SeHouseholdSetupFeatureSelfInfoModule } from '../lib/se-household-setup-feature-self-info.module'
import { SelfInfoDocsComponent } from './self-info-docs/self-info-docs.component'

@NgModule({
  declarations: [SelfInfoDocsComponent],
  exports: [SelfInfoDocsComponent],
  imports: [
    CommonModule,
    SeFeCardModule,
    SeHouseholdSetupFeatureSelfInfoModule
  ]
})
export class SeHouseholdSetupFeatureSelfInfoDocsModule {}
